import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion for animations
import ContractingData from '../data/ContractingData';
import WhyImage from '../assets/why-contracting.png';
import '../styles/contracting.css';
import Footer from '../components/Footer';
import Call from '../components/Call';

function Contracting() {
  return (
    <motion.div 
      className='contracting-container'
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ duration: 0.8 }}
    >
      {/* Hero Section */}
      <motion.div 
        className="contracting-hero"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <h1>Our Contracting Services</h1>
        <p>
          At <span>NEXTCASTLE ENERGY LIMITED</span>, we provide comprehensive contracting services 
          designed to support oil and gas projects efficiently. From project planning to execution, 
          we ensure high-quality deliverables while adhering to industry regulations and safety standards.
        </p>
      </motion.div>

      {/* Contracting Services */}
      <div className="contracting-services">
        <motion.div 
          className="contracting-service-text"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>Our Contracting Capabilities</h2>
        </motion.div>

        <div className="contracting-service-cards">
          {ContractingData.map((item) => (
            <motion.div 
              key={item.id} 
              className="contracting-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <div className="title"><h2>{item.title}</h2></div>
              <div className="desc"><p>{item.description}</p></div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="why-contracting-container">
        <motion.div 
          className="why-contracting-image"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <img src={WhyImage} alt="nextcastle-why-choose-us" />
        </motion.div>                                  

        <motion.div 
          className="why-contracting-text"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <h2>Why Choose <span>NEXTCASTLE ENERGY LIMITED</span> for Contracting?</h2>
          <ul>
            <li><span>Expert Project Management:</span> We streamline processes to ensure efficiency and timely project completion.</li>
            <li><span>Safety & Compliance:</span> Our contracting services adhere to international safety and environmental regulations.</li>
            <li><span>Comprehensive Solutions:</span> From manpower supply to full project execution, we cover every aspect of contracting.</li>
            <li><span>Cost-Effective Execution:</span> We optimize resources to deliver high-quality results within budget.</li>
            <li><span>Innovative Strategies:</span> We leverage modern technologies and industry best practices.</li>
          </ul>
        </motion.div>
      </div>

      <Call />
      <Footer />
    </motion.div>
  );
}

export default Contracting;
